var jQuery = $;
import slick from '../../node_modules/slick-carousel/slick/slick.min.js';
import fancy from '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const app = {
    /**
     * Initialize.
     */
    init() {
        // Smooth scroll to anchor
        this.smoothAnchor();

        this.initSwiperSliders();

        // Toggle FAQ's
        this.toggleFAQs();

        // Fade sections in on scroll
        this.fadeInOnScroll();

        // Register our event listeners
        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger').on('click', $.proxy(this.toggleHamburgerMenu, this));
    },

    /** Handles the scroll event. */
    windowScrollHandler() {
        $('header').toggleClass('is-scrolled', $(window).scrollTop() > 0);
    },

    // FAQ
    toggleFAQs() {
        function closeItem($item) {
            $item.removeClass("is-opened");
            $item.find(".faq-heading").removeClass("is-opened");
            $item.find(".icon").removeClass("opened").addClass("closed");
            $item.find(".faq-body").stop(true, true).slideUp(500).addClass("hidden");
        }

        function openItem($item) {
            $item.addClass("is-opened");
            $item.find(".faq-heading").addClass("is-opened");
            $item.find(".icon").removeClass("closed").addClass("opened");
            $item.find(".faq-body").stop(true, true).slideDown(500).removeClass("hidden");
        }

        const $allItems = $(".faq-item");
        $allItems.each(function () {
            $(this).removeClass("is-opened");
            $(this).find(".faq-heading").removeClass("is-opened");
            $(this).find(".icon").removeClass("opened").addClass("closed");
            $(this).find(".faq-body").stop(true, true).hide().addClass("hidden");
        });

        const $second = $allItems.eq(0);
        if ($second.length) {
            openItem($second);
        }

        $(".faq-heading").off("click.toggleFAQs").on("click.toggleFAQs", function () {
            const $heading = $(this);
            const $currentItem = $heading.closest(".faq-item");
            const $currentBody = $currentItem.find(".faq-body");

            $allItems.not($currentItem).each(function () {
                closeItem($(this));
            });

            if ($currentBody.hasClass("hidden")) {
                openItem($currentItem);
            } else {
                closeItem($currentItem);
            }
        });
    },

    /** Open hamburger menu. */
    toggleHamburgerMenu() {
        $(".hamburger").toggleClass('is-active');
        $("nav.navigation").toggleClass('visible');
        $("header").toggleClass('is-active');
        $("body").toggleClass('is-locked');
    },

    /** Smooth scroll to Anchor */
    smoothAnchor() {
        var $root = $('html, body');

        $('a:not(.toggle-categories)[href^="#"]').click(function () {
            $root.animate({
                scrollTop: $($.attr(this, 'href')).offset().top - 120
            }, 500);

            return false;
        });
    },

    /** Fade sections in on scroll */
    fadeInOnScroll() {
        $.fn.initFadeIn = function () {
            $('.section').each(function () {
                let top_of_element = $(this).offset().top + 150;
                let bottom_of_element = $(this).offset().top + $(this).outerHeight();
                let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
                let top_of_screen = $(window).scrollTop();
                if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) && !$(this).hasClass('is-visible')) {
                    $(this).addClass('is-visible');
                }
            });
        };
        $.fn.initFadeIn();
        $(window).scroll(function () {
            $.fn.initFadeIn();
        });
    },

    initSwiperSliders() {

        if ($('.logo-slider.swiper').length && $('.logo-slider.swiper').length) {
            let swiperLogos = new Swiper(".logo-slider.swiper", {
                loop: true,
                spaceBetween: 20,
                slidesPerView: 3,
                freeMode: true,
                breakpoints: {
                780: {
                    slidesPerView: 5.2,
                    spaceBetween: 80,
                    centeredSlides: false,
                },
                 1024: {
                    slidesPerView: 7.2,
                    spaceBetween: 80,
                    centeredSlides: false,
                },
            },
            });

            // CSS Marquee animation
            const wrapper = document.querySelector('.logo-slider.swiper .swiper-wrapper');
            const slides = wrapper.querySelectorAll('.swiper-slide');

            // Clone slides for seamless loop
            slides.forEach(slide => {
                wrapper.appendChild(slide.cloneNode(true));
            });

            wrapper.classList.add('marquee-animation');
        }

        if ($('.cases-slider.swiper').length) {
            let swiperCases = new Swiper(".cases-slider.swiper", {
                effect: "fade",
                fadeEffect: {
                    crossFade: true,
                },
                loop: true,
                slidesPerView: 1,
                spaceBetween: 30,
                // Mobile: laat de hoogte meebewegen met de gestackte content.
                // Desktop (md+): vaste, gelijke hoogte voor alle slides.
                autoHeight: true,
                breakpoints: {
                    768: {
                        autoHeight: false,
                    },
                },
                navigation: {
                    prevEl: ".cases-slider-prev",
                    nextEl: ".cases-slider-next",
                },
            });
        }
    },
};
$(document).ready($.proxy(app.init, app));
